import { ScoreDetailContext } from "./context";
import { Score } from "src/api/client-api/post/scoreSchema.ts";
import { Score as SureScore } from "src/types";
import { useParams } from "react-router-dom";
import { ScoreDetailBuilder } from "./ScoreDetailBuilder";
import { useDrilldown } from "./useDrilldown";
import { ScoreState } from "../EntityBasedScore/useEntityBasedScoreParams";
import { TabConfig } from "src/components/ScoreDetail/InnerTabs/ScoreDetailTabs";
import { ScoreService } from "../EntityBasedScore/ScoreService";

export type ScoreDetailUrls = {
    scoreListUrl: string;
    selectedScoreUrl: string;
};

type ScoreDetailContextProviderProps = {
    allScores: SureScore[];
    prevCampaign: string | undefined;
    children: JSX.Element | JSX.Element[];
    goBackLink: string;
    scores: Partial<Record<string, Score>>;
    scoreDetail: SureScore;
    scoreDetailBuilder: ScoreDetailBuilder;
    scoreState: ScoreState;
    tabConfig: TabConfig;
};

export const ScoreDetailContextProvider = (props: ScoreDetailContextProviderProps) => {
    const {
        allScores,
        children,
        goBackLink,
        scores,
        scoreDetail,
        scoreDetailBuilder,
        scoreState,
        tabConfig,
        prevCampaign = "Previously",
    } = props;

    const { scoreId } = useParams<{ scoreId: string }>();
    const _scoreId = Number(scoreId);

    const drilldownState = useDrilldown({
        title: scoreDetail.title,
        goBackLink: goBackLink,
    });

    const allScoresFiltered = allScores.filter((item) => item.id === _scoreId);
    const _s = { [_scoreId]: scores[_scoreId] };
    const scoreList = ScoreService.getScoreList(
        allScoresFiltered,
        _s,
        (scoreId, scoreVarId) => {
            scoreState.selectVariation(scoreId, scoreVarId);
        },
        scoreState.lastSelectedVariation,
    );

    return (
        <ScoreDetailContext.Provider
            value={{
                scoreDetailBuilder,
                scoreDetail,
                drilldownState,
                tabConfig,
                scoreList,
                prevCampaign,
            }}
        >
            {children}
        </ScoreDetailContext.Provider>
    );
};
